'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line import/prefer-default-export
var DROPDOWN_CONTEXT = exports.DROPDOWN_CONTEXT = '__DROPDOWN_CONTEXT__';


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/Dropdown/constants.js
// module id = 239
// module chunks = 2